import React, { useState } from "react";
import { AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import { useTranslation } from "react-i18next";
import { FILE_SOURCES_DEPLOYMENT, PROCESS_STATUS_NAME } from "src/constant/common";
import { FORM_NAME } from "src/pages/ProjectInstance/detail";
import FieldDisplay from "./FieldDisplay";
import EditableField from "./EditableField";
import FileDisplayField from "./FileDisplayField";

const MainSection = ({ errors, register, instanceData, navigationPrompt, isAllowEdit, setValue }) => {
  const [isEditName, setIsEditName] = useState(false);
  const [isEditDescription, setIsEditDescription] = useState(false);

  const { t } = useTranslation("project-instance");

  const getStatus = (status, host, port) => {
    if (!host && !port) return status;
    return `${status} (${host || port})`;
  };

  const toggleEdit = (fieldName) => {
    navigationPrompt(true);

    if (fieldName === FORM_NAME.MAIN.NAME) {
      setIsEditName(!isEditName);
    }
    if (fieldName === FORM_NAME.MAIN.DESCRIPTION) {
      setIsEditDescription(!isEditDescription);
    }
  };

  const isUpdatedDayNewerThanDeployDay = (updatedAt, lastDeploy) => {
    if (!updatedAt || !lastDeploy) return false;
    const updatedDate = new Date(updatedAt);
    const deployDate = new Date(lastDeploy);
    return updatedDate > deployDate;
  };

  const isShowMsgLatestRegistriesNotDeployed = (status, latestDeploy, latestUpdate, fileSource) => {
    if (status === PROCESS_STATUS_NAME.DRAFT) {
      return true;
    }
    if (isUpdatedDayNewerThanDeployDay(latestUpdate, latestDeploy) && fileSource === FILE_SOURCES_DEPLOYMENT.CLOUD) {
      return true;
    }

    return false;
  };

  return (
    <AccordionItem>
      <AccordionHeader targetId="1" className="mt-0 fw-bold">
        {t("detail.main_section")}
      </AccordionHeader>
      <AccordionBody accordionId="1">
        <FieldDisplay
          label={t(`detail.${FORM_NAME.MAIN.ID}`)}
          value={instanceData?.[FORM_NAME.MAIN.INCREMENT_ID] && `#${instanceData[FORM_NAME.MAIN.INCREMENT_ID]}`}
        />

        <FieldDisplay
          label={t(`detail.${FORM_NAME.MAIN.STATUS}`)}
          value={
            instanceData?.[FORM_NAME.MAIN.STATUS] &&
            getStatus(
              instanceData[FORM_NAME.MAIN.STATUS],
              instanceData?.latest_deployment?.instance_info?.[FORM_NAME.MAIN.HOST],
              instanceData?.latest_deployment?.instance_info?.[FORM_NAME.MAIN.PORT]
            )
          }
        />

        <EditableField
          className={`${isEditName && isEditDescription ? "mb-4" : ""}`}
          label={t(`new.${FORM_NAME.MAIN.NAME}`)}
          fieldName={FORM_NAME.MAIN.NAME}
          value={instanceData?.[FORM_NAME.MAIN.NAME]}
          isEditing={isEditName}
          onToggleEdit={toggleEdit}
          register={register}
          setValue={setValue}
          errors={errors}
          placeholder={t("new.name_placeholder")}
          requiredMessage={t("field_required", { field_name: t("new.name") })}
          maxLength={255}
          maxLengthMessage={t("maxlength")}
          isAllowEdit={isAllowEdit}
        />

        <EditableField
          label={t(`new.${FORM_NAME.MAIN.DESCRIPTION}`)}
          fieldName={FORM_NAME.MAIN.DESCRIPTION}
          value={instanceData?.[FORM_NAME.MAIN.DESCRIPTION]}
          isEditing={isEditDescription}
          onToggleEdit={toggleEdit}
          register={register}
          setValue={setValue}
          errors={errors}
          placeholder={t("new.description_placeholder")}
          requiredMessage={t("field_required", { field_name: t("new.description") })}
          isAllowEdit={isAllowEdit}
          isTextarea={true}
          rows={4}
          maxLength={2000}
          maxLengthMessage={t("textarea_maxlength")}
        />

        <FieldDisplay
          label={t(`detail.${FORM_NAME.MAIN.LAST_DEPLOY}`)}
          value={
            instanceData?.latest_deployment?.[FORM_NAME.MAIN.LAST_DEPLOY] &&
            `${instanceData?.latest_deployment?.[FORM_NAME.MAIN.LAST_DEPLOY]} JST`
          }
        />

        <FileDisplayField
          label={t(`detail.${FORM_NAME.MAIN.DASHBOARD_OPI}`)}
          fieldName={FORM_NAME.MAIN.DASHBOARD_OPI}
          fileData={instanceData?.[FORM_NAME.MAIN.DASHBOARD_OPI]}
          updateInfo={instanceData?.[FORM_NAME.MAIN.OPI_UPDATE]}
          status={instanceData?.[FORM_NAME.MAIN.STATUS]}
          showWarning={isShowMsgLatestRegistriesNotDeployed(
            instanceData?.[FORM_NAME.MAIN.STATUS],
            instanceData?.latest_deployment?.[FORM_NAME.MAIN.LAST_DEPLOY],
            instanceData?.[FORM_NAME.MAIN.OPI_UPDATE],
            instanceData?.[FORM_NAME.MAIN.OPI_SOURCE]
          )}
          warningMessage={t("detail.latest_registries_not_deployed")}
        />

        <FileDisplayField
          label={t(`detail.${FORM_NAME.MAIN.MDB}`)}
          fieldName={FORM_NAME.MAIN.MDB}
          fileData={instanceData?.[FORM_NAME.MAIN.MDB]}
          updateInfo={instanceData?.[FORM_NAME.MAIN.MDB_UPDATE]}
          status={instanceData?.[FORM_NAME.MAIN.STATUS]}
          showWarning={isShowMsgLatestRegistriesNotDeployed(
            instanceData?.[FORM_NAME.MAIN.STATUS],
            instanceData?.latest_deployment?.[FORM_NAME.MAIN.LAST_DEPLOY],
            instanceData?.[FORM_NAME.MAIN.MDB_UPDATE],
            instanceData?.[FORM_NAME.MAIN.MDB_SOURCE]
          )}
          warningMessage={t("detail.latest_registries_not_deployed")}
        />

        <FieldDisplay label={t(`detail.${FORM_NAME.MAIN.OWNER}`)} value={instanceData?.[FORM_NAME.MAIN.OWNER]} />
      </AccordionBody>
    </AccordionItem>
  );
};

export default MainSection;
